class StickyHeader extends HTMLElement {
  
  constructor() {
    super();
  }
  
  connectedCallback() {
    
    this.header = document.querySelector('.header-section');
    this.mainContent = document.getElementById('main');
    this.scrollThreshold = -30;
    this.scrolledClass = 'is-scrolled';
    this.notScrolled = true;
    this.predictiveSearch = this.querySelector('predictive-search');
    
    // listen on scroll
    this.onScrollHandler = this.headerScrollTest.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
    window.addEventListener('load', this.onScrollHandler, false);
    
    // initial test
    this.headerScrollTest();
  }
  
  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  
  headerScrollTest() {
    
    // skip if search is open
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
    // get top scroll position of main section
    const mainTop = this.mainContent.getBoundingClientRect().top;
    
    // test main section vs scroll threshold
    if ( this.notScrolled && mainTop < this.scrollThreshold ) {
      this.notScrolled = false;
      this.header.classList.add(this.scrolledClass);
    }
    else if ( !this.notScrolled && mainTop >= this.scrollThreshold ) {
      this.notScrolled = true;
      this.header.classList.remove(this.scrolledClass);
    }
  }
  
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
  
}

customElements.define('sticky-header', StickyHeader);


class MenuDrawer extends DrawerComponent {
  constructor() {
    super();
  }
//   get menuItems() {
//     if (!this._menuItems) {
//       this._menuItems = this.querySelectorAll('.menu-drawer__menus:not(.active) > li');
//     }
//     return this._menuItems;
//   }
// 
//   prepareToShow() {
//     super.prepareToShow();
//     setTimeout(() => {
//       this.animateMenuItems();
//     }, 300);
//   }
// 
//   animateMenuItems() {
//     PCOtheme.Motion.animate(
//       this.menuItems,
//       {
//         transform: ['translateX(-20px)', 'translateX(0)'],
//         opacity: [0, 1],
//       },
//       {
//         duration: 0.6,
//         easing: [0.075, 0.82, 0.165, 1],
//         delay: PCOtheme.Motion.stagger(0.1),
//       }
//     ).finished.then(() => {
//       this.menuItems.forEach((item) => item.removeAttribute('style'));
//     });
//   }
// 
//   handleAfterHide() {
//     super.handleAfterHide();
//     setTimeout(() => {
//       this.querySelectorAll('details[is=menu-drawer-details]').forEach((menu) => {
//         menu.onCloseButtonClick();
//       });
//     });
//   }
}
customElements.define('menu-drawer', MenuDrawer);